import React, { useState } from 'react';
import RFIGridView from './RFIGridView';
import RFIEditor from './RFIEditor';

interface RFIManagerProps {
  estimationId: string;
  projectName?: string;
  contractNumber?: string;
}

const RFIManager: React.FC<RFIManagerProps> = ({ estimationId, projectName, contractNumber }) => {
  const [selectedRFIId, setSelectedRFIId] = useState<string | null>(null);
  const [view, setView] = useState<'grid' | 'editor'>('grid');

  const handleSelectRFI = (rfiId: string) => {
    setSelectedRFIId(rfiId);
    setView('editor');
  };

  const handleBackToGrid = () => {
    setView('grid');
    setSelectedRFIId(null);
  };

  const handleCreateNew = async () => {
    // This will be handled by AI in the chat
    // For now, just show a message
    console.log('💬 Ask the AI Assistant to create an RFI');
  };

  return (
    <>
      {view === 'grid' ? (
        <RFIGridView
          estimationId={estimationId}
          onSelectRFI={handleSelectRFI}
          onCreateNew={handleCreateNew}
        />
      ) : (
        <RFIEditor
          rfiId={selectedRFIId}
          estimationId={estimationId}
          projectName={projectName}
          contractNumber={contractNumber}
          onBack={handleBackToGrid}
        />
      )}
    </>
  );
};

export default RFIManager;

